export class RentalPracticesModel {
  public id: number;
  public codiceAzione: string;
  public enabled: boolean;
  public creator: string;
  public created: Date;
  public modifier: string;
  public modified: Date;
}
